import jwt from "jwt-decode";

export const TOKEN_KEY = "AUTHORIZATION_TOKEN"

export function writeNewToken(token) {
    window.sessionStorage.setItem(TOKEN_KEY, token)
}

export function readToken() {
    // console.log("token is ",window.sessionStorage.getItem(TOKEN_KEY))
    return window.sessionStorage.getItem(TOKEN_KEY)
}

export function clearSession() {
    window.sessionStorage.clear()
}

export function getAdminRoles() {

    const token = readToken()
    if (typeof token !== "undefined" && token.length > 0) {
        try {
            return [...jwt(token).realm_access.roles.map(item => {
                return item
            })]
        } catch (e) {
            return []
        }
    } else
        return []

}